<fuse-widget class="widget p-0 h-100-p" fxLayout="column">
    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p" fxLayout="column" fxLayoutAlign="stretch stretch">

        <div class="px-16 py-8 border-bottom title-bar mat-accent-bg" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="mat-accent-bg" fxLayout="row" fxLayoutAlign="start center">
                <div class="h3 title pr-4">{{title}}</div>
                <div *ngIf="_data?.length>0" fxLayout="row" fxLayoutAlign="start center">
                    <div class="h3 secondary">({{_data?.length}})</div>
                </div>
            </div>

            <div *ngIf="_showSubjectTypeFilter && (subjectTypeNames.length>0)" class="actions mat-accent-bg" fxLayout="row" fxLayoutAlign="start center" >

                <mat-divider class='style-fix' [vertical]="true"></mat-divider>
                    
                <span class="h4">{{filterSubjectType}}</span>
                <button mat-icon-button [matMenuTriggerFor]="subjectTypeMenu">
                    <mat-icon class="mat-accent-bg">arrow_drop_down</mat-icon>
                </button>
                <mat-menu #subjectTypeMenu="matMenu">
                    <button mat-menu-item *ngFor="let subjectType of subjectTypeNames" (click)="filterBySubjectType(subjectType)">{{subjectType}}</button>
                </mat-menu>
            </div>
        </div>
        <subject-list style="overflow-y: auto; height: 100%;"
            [subjects]="_data"
            [allowEdit]="allowEdit"
            [allowDelete]="allowDelete"
            [allowEditRelationship]="allowEditRelationship"
            [allowSelect]="allowSelect"
            [readOnly]="readOnly || userReadOnly"
            [admin]="admin"
            (onEdit)="edit($event)" 
            (onDelete)="delete($event)" 
            (onSelect)="select($event)"
            (onChangeRelationship)="changeRelationship($event)" 
            [noContentMessage] = "noContentMessage"
        ></subject-list>
    </div>
    <!-- / Front -->

</fuse-widget>